import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem("klt_consent"));
  if (!visible || window.location.pathname.startsWith("/devis/")) return null;
  const accept = () => { localStorage.setItem("klt_consent", "1"); setVisible(false); };
  return (
    <div className="fixed bottom-20 md:bottom-0 inset-x-0 z-[45] p-3 sm:p-4 pointer-events-none" data-testid="consent-banner">
      <div className="max-w-3xl mx-auto rounded-2xl border border-border bg-card/95 backdrop-blur shadow-xl p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 pointer-events-auto">
        <Cookie className="w-5 h-5 text-primary shrink-0" />
        <p className="text-sm text-muted-foreground flex-1">
          Nous utilisons uniquement des données strictement nécessaires au fonctionnement de l'application (session, préférences).
          Aucun traceur publicitaire. En savoir plus dans notre{" "}
          <a href="/confidentialite" className="text-primary font-medium hover:underline" data-testid="consent-privacy-link">politique de confidentialité</a>.
        </p>
        <Button onClick={accept} data-testid="consent-accept-btn" className="rounded-xl w-full sm:w-auto shrink-0">J'ai compris</Button>
      </div>
    </div>
  );
}
